import { email, required } from 'vuelidate/lib/validators';

export default {
  validations: {
    remindPasswordApi: {
      mail: {
        required,
        email,
      },
    },
  },
};
